module.exports = __webpack_public_path__ + "static/media/patients_icon.106d3e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/patients_icon.png
// module id = 308
// module chunks = 0